import request from "../helpers/request";
import { AuthHeader, getUserToken } from "../helpers";
import jwtDecode from "jwt-decode";
import React from "react";

export {
  getCookingForms,
  getCareTyping,
  getHousingTypes,
  getDiets,
  createDepartment,
  getLocations,
  getDepartments,
  getDepartmentById,
  getDepartmentsByLocationId,
  updateDepartment,
  deleteDepartmentById
};

function getCookingForms() {
  return request({
    url: "cooking-forms/",
    method: "GET",
    headers: AuthHeader(),
  }).then((res) => {
    return createObjectList(res);
  });
}

function getDepartments(locationId) {
  return request({
    url: `departments/location/${locationId}`,
    method: "GET",
    headers: AuthHeader(),
  }).then((res) => {
    const options = createOptionsList(res);
    return options;
  });
}

function deleteDepartmentById(departmentId) {
  return request({
    url: `departments/${departmentId}`,
    method: "DELETE",
    headers: AuthHeader()
  }).then((res) => {
    return res;
  })
}

function getCareTyping() {
  return request({
    url: "care-typing/",
    method: "GET",
    headers: AuthHeader(),
  }).then((res) => {
    return createObjectList(res);
  });
}

function getDiets() {
  return request({
    url: "diets/",
    method: "GET",
    headers: AuthHeader(),
  }).then((res) => {
    return createObjectList(res);
  });
}

function getDepartmentsByLocationId(locationId) {
  const token = getUserToken();
  let user = "";
  if (token) user = jwtDecode(token);
  let url = "departments/location/" + locationId;
  if (user.user_type == 1) url = "departments/";
  return request({
    url: url,
    method: "GET",
    headers: AuthHeader(),
  }).then((res) => {
    return res;
  });
}

function getDepartmentById(departmentId) {
  return request({
    url: "departments/admin/" + departmentId,
    method: "GET",
    headers: AuthHeader(),
  }).then((res) => {
    return res;
  });
}

function getLocations(customerId) {
  return request({
    url: `locations/${customerId}`,
    method: "GET",
    headers: AuthHeader(),
  }).then((res) => {
    const options = createOptionsList(res);
    return options;
  });
}

function getHousingTypes() {
  return request({
    url: "housing-types/",
    method: "GET",
    headers: AuthHeader(),
  }).then((res) => {
    const options = createOptionsList(res);
    return options;
  });
}

// Creates list for selectbox with result from database
function createOptionsList(result) {
  const array = Object.values(result)[0];
  const options = array.map((x) => <option value={x.id}>{x.name}</option>);
  return options;
}

// Creates list for multiselectbox with result from database
function createObjectList(result) {
  const array = Object.values(result)[0];
  let options = [];
  array.map((x) => {
    options.push({ label: x.name, value: x.id });
  });
  return options;
}

function createDepartment(
  location_id,
  name,
  housing_type_id,
  care_typing,
  cooking_forms,
  amount_of_patients,
  amount_of_dietpatients,
  standard_vse
) {
  return request({
    url: "departments/create",
    method: "POST",
    data: {
      location_id: location_id,
      name: name,
      housing_type_id: housing_type_id,
      care_typing: care_typing,
      cooking_forms: cooking_forms,
      amount_of_patients: amount_of_patients,
      amount_of_dietpatients: amount_of_dietpatients,
      standard_vse: standard_vse,
    },
    headers: AuthHeader(),
  }).then((res) => {
    return res;
  });
}

function updateDepartment(
  departmentId,
  name,
  housing_type_id,
  care_typing,
  cooking_forms,
  amount_of_patients,
  amount_of_dietpatients,
  standard_vse
) {
  return request({
    url: "departments/update/" + departmentId,
    method: "PUT",
    data: {
      name: name,
      housing_type_id: housing_type_id,
      care_typing: care_typing,
      cooking_forms: cooking_forms,
      amount_of_patients: amount_of_patients,
      amount_of_dietpatients: amount_of_dietpatients,
      standard_vse: standard_vse,
    },
    headers: AuthHeader(),
  }).then((res) => {
    return res;
  });
}
